import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    height: 100%;
  }

  .preview-container {
    box-shadow: var(--sds-size-depth-200);
    overflow: hidden;
    border: var(--sds-size-stroke-border) solid var(--sds-color-background-default-tertiary);
    border-radius: var(--sds-size-radius-400);
    width: calc(100% - var(--sds-size-stroke-border) * 3);
    height: calc(100% - var(--sds-size-stroke-border) * 3);
    display: block;
    align-content: center;
  }

  .preview-container iframe {
    border: var(--sds-size-stroke-border) solid var(--sds-color-background-default-tertiary);
    border-radius: var(--sds-size-radius-400);

    min-width: 300px;
    aspect-ratio: 9 / 20;

    max-width: calc(100% - var(--sds-size-space-1200));
    max-height: calc(100% - var(--sds-size-space-1200));

    object-fit: contain;
    margin: auto;
    display: block;
  }

  .error-message {
    color: var(--sds-color-text-danger-default);
    padding: var(--sds-size-space-600);
    text-align: center;
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-medium);
  }
`;
